var callBackNo = 0;
var readyFnList = [];
function generateFnName () {
	callBackNo++;
	return 'COVERAPP_CallBack_' + callBackNo;
}

var COVERAPP = {
	// 基础属性类
	Attribute: {
		// userAgent
		UA: navigator.userAgent,

		// version
		version: '1.4.0',

		// 判断是否为app
		isApp: function(){
			var ua = this.UA;
	    	if (/TheCover/i.test(ua)) {
	      		return true;
	    	}
	        return false;
		},

		// 判断是否是ios
		isIOS: function(){
			var ua = this.UA;
		    if (/ios/i.test(ua) || /iphone/i.test(ua) || /ipad/i.test(ua) || /ipod/i.test(ua)) {
		       return true;
		    }
		    return false;
		},

		// 判断是否是android
	    isAndroid: function () {
	    	var ua = this.UA;
	    	if (/android/i.test(ua)) {
	      		return true;
	    	}
	        return false;
	    },

	    // 获取客户端版本号
	    appVersion: function(){
	    	var ua = this.UA;
	    	var version = ua.split('(TheCover_')[1].split('_')[0];
	    	return version;
	    },

	    // 获取系统类型
	    systemType: function(){
	    	var ua = this.UA;
	    	var sys = ua.split('(TheCover_')[1].split('_')[1];
	    	return sys;
	    },

	    // 设备标识
	    deviceId: function(){
	    	var ua = this.UA;
	    	var id = ua.split('(TheCover_')[1].split('_')[2];
	    	return id;
	    },

	    // 版本比较
	    vercp: function(version){
	    	var appvs = this.appVersion.split('.'), vs = version.split('.');

	    	if(appvs[0] < vs[0]){
	    		return 'old';
	    	}

	    	if(appvs[0] > vs[0]){
	    		return 'new';
	    	}

	    	if(appvs[0] == vs[0] && appvs[1] < vs[1]){
	    		return 'old';
	    	}

	    	if(appvs[0] == vs[0] && appvs[1] > vs[1]){
	    		return 'new';
	    	}

	    	if(appvs[0] == vs[0] && appvs[1] == vs[1] && appvs[2] < vs[2]){
	    		return 'old';
	    	}

	    	if(appvs[0] == vs[0] && appvs[1] == vs[1] && appvs[2] > vs[2]){
	    		return 'new';
	    	}

	    	if(appvs[0] == vs[0] && appvs[1] == vs[1] && appvs[2] == vs[2]){
	    		return 'new';
	    	}

	    }
	},

	// 界面类
	UI: {
		// 对话框组
		Dialog: function(obj){
			var funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if(COVERAPP.Attribute.isIOS()){
				window.webkit.messageHandlers.Dialog.postMessage(obj);
				return false;
			}

			if(COVERAPP.Attribute.isAndroid()){
				AndroidBridging.dialog(JSON.stringify(obj));
				return false;
			}
			
		},

		// alert
		alert: function(msg, callback){
			this.Dialog({
				title: '',
	    		msg: msg,
	    		buttons: ['确定'],
	    		callback: function(ret){
	    			
	    		}
			});
		},

		// 图集预览
		previewImage: function(obj){
			if(COVERAPP.Attribute.isIOS()){
				window.webkit.messageHandlers.PreviewImage.postMessage(obj);
				return false;
			}

			if(COVERAPP.Attribute.isAndroid()){
				AndroidBridging.previewImage(JSON.stringify(obj));
				return false;
			}
		}
	},

	// 功能方法类
	Method: {
		/**
		 * 主动分享
		 * @param  {{imgUrl: string, origin: string, link: string, callback: callback, title: string, type: string, desc: string}} obj 参数对象
		 * @param  {string} obj.callback 回调函数名
		 */
		Share: function(obj){
			var funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if(COVERAPP.Attribute.isIOS()){
				window.webkit.messageHandlers.Share.postMessage(obj);
				return false;
			}

			if(COVERAPP.Attribute.isAndroid()){
				AndroidBridging.share(JSON.stringify(obj));
				return false;
			}
			
		},

		/**
		 * 被动分享 APP右上角
		 * @param  {Object} obj 参数对象
		 * @param  {string} obj.callback 回调函数名
		 */
		onshare: function (obj) {
			var funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				try {
					window.webkit.messageHandlers.onShare.postMessage(obj);
				} catch (e) {
				}
			} else {
				if (window.AndroidBridging) {
					window.AndroidBridging.onShare(JSON.stringify(obj));
				}
			}
		},

		/**
		 * 打开登录 成功返回用户信息
		 * @param  {{callback: callback}} obj 参数对象
		 * @param  {string} obj.needMobile 值为'1'则需要绑定手机号
		 * @param  {string} obj.callback 回调函数名
		 */
		OpenLogin: function(obj){
			var funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if(COVERAPP.Attribute.isIOS()){
				window.webkit.messageHandlers.Login.postMessage(obj);
				return false;
			}

			if(COVERAPP.Attribute.isAndroid()){
				// console.log('denglu');
				AndroidBridging.login(JSON.stringify(obj));
				return false;
			}
		},

		/**
		 * 获取用户信息 mobile device_id push_id等
		 * @param  {Object} obj 参数对象
		 * @param  {string} obj.callback 回调函数名
		 */
		GetUser: function(obj) {
			var funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.wcUser
					? window.webkit.messageHandlers.wcUser.postMessage(obj)
					: window.webkit.messageHandlers.User.postMessage(obj);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				// 老版本user，新版本wcuser
				AndroidBridging.wcuser
					? AndroidBridging.wcuser(JSON.stringify(obj))
					: AndroidBridging.user(JSON.stringify(obj));
				return false;
			}
		},

		/**
		 * 获取通知是否打开（2018世界杯使用）
		 * @param  {Object} obj 参数对象
		 * @param  {string} obj.callback 回调函数名 非必须  参数JSON字符串，包含status('success', 'cancel')
		 */
		getNotificationStatus: function (obj) {
			var funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if(COVERAPP.Attribute.isIOS()){
				window.webkit.messageHandlers.getNotificationStatus.postMessage(obj);
				return false;
			}
			if(COVERAPP.Attribute.isAndroid()){
				AndroidBridging.getNotificationStatus(JSON.stringify(obj));
				return false;
			}
		},

		/**
		 * 去设置页面 （2018世界杯使用）
		 */
		goSettingNotification: function () {
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.goSettingNotification.postMessage('');
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.goSettingNotification();
				return false;
			}
		},

		/**
		 * 生成签名
		 * @param  {Object} obj 参数对象
		 * @param  {string} obj.callback 回调函数名 非必须  参数JSON字符串，包含status('success', 'cancel')
		 */
		generateSign: function (obj) {
			var timestamp = new Date().getTime();
			var token = '';
			var account = Math.round(Math.random() * 10000000);
			var params = {
				timestamp: timestamp,
				token: token,
				account: account
			};
			var funName = generateFnName()
			// 之前客iOS客户端没有返回传递过去的参数，需要自己把参数传给回调
			window[funName] = function (data) {
				obj.callback.call(window, data, params);
			};
			params.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.generateSign.postMessage(params);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.generateSign(JSON.stringify(params));
				return false;
			}
		},

		/**
		 * 加积分
		 * @param  {Object} obj 参数对象
		 * @param  {string} obj.callback 回调函数名 非必须  参数JSON字符串，包含status('success', 'cancel')
		 */
		integral: function (obj) {
			var funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.integral.postMessage(obj);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.integral(JSON.stringify(obj));
				return false;
			}
		},
		
		/**
		 * 去积分商城
		 */
		goIntegralMall: function () {
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.goIntegralMall.postMessage('');
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.goIntegralMall();
				return false;
			}
		},

		/**
		 * 复制到剪贴板
		 * @param  {Object} obj 参数对象
		 * @param  {string} obj.text 复制的文本
		 * @param  {string} obj.callback 回调函数名 非必须  参数JSON字符串，包含status('success', 'cancel')
		 */
		copyToClipborad: function (obj) {
			var funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.copyToClipborad.postMessage(obj);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.copyToClipborad(JSON.stringify(obj));
				return false;
			}
		},

		/**
		 * 调起绑定手机号
		 * @param  {{callback: callback}} obj 参数对象
		 * @param  {string} obj.callback 回调函数名
		 */
		bindMobile: function (obj) {
			var funName = generateFnName()
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.bindMobile.postMessage(obj);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.bindMobile(JSON.stringify(obj));
				return false;
			}
		},

		/**
		 * 返回
		 *//**
		 * 微信授权
		 */
		wxAuthorize:function (obj) {
			let funName = generateFnName();
			window[funName] = obj.callback;
			obj.callback = funName;
			if (COVERAPP.Attribute.isIOS()) {
				window.webkit.messageHandlers.wxAuthorize.postMessage(obj);
				return false;
			}
			if (COVERAPP.Attribute.isAndroid()) {
				AndroidBridging.wxAuthorize(JSON.stringify(obj));
				return false;
			}
		},
		Back: function(){
			if(COVERAPP.Attribute.isIOS()){
				window.webkit.messageHandlers.Back.postMessage('');
				return false;
			}

			if(COVERAPP.Attribute.isAndroid()){
				AndroidBridging.back();
				return false;
			}
		},



	},

	/**
	 * ready方法 需要确保桥可以使用是，放在ready方法里
	 * @param  {Function} fn 需要执行的函数
	 */
	ready: function (fn) {
		readyFnList.push(fn);
	}
};

window.COVERAPP_CallBack_ready = function () {
	for (var i = 0; i < readyFnList.length; ++i) {
		readyFnList[i].call();
	}
};

window.COVERAPP = COVERAPP;